import { Text } from '@youversion/design-system-components';
import PersonStroked from '@youversion/design-system-icons/lib/PersonStroked';
import Image from 'next/image';
import { useState } from 'react';

interface Props {
  avatarUrl?: string;
  name?: string;
}

export function ProfileMenuButtonImage({ avatarUrl, name }: Props) {
  const [imageFailed, setImageFailed] = useState(false);

  if (avatarUrl && !imageFailed) {
    return (
      <div className='size-4'>
        <Image
          alt={name ?? ''}
          height={32}
          onError={() => setImageFailed(true)}
          src={`https:${avatarUrl}`}
          style={{ borderRadius: '6rem' }}
          width={32}
        />
      </div>
    );
  } else if (name) {
    return (
      <Text
        className='bg-black dark:border-small dark:border-white rounded-4 text-white pli-0.25 plb-0.5 block w-4'
        size='md'
        variant='paragraph'
      >
        {name.substring(0, 1).toUpperCase()}
      </Text>
    );
  } else {
    return <PersonStroked box-size={4} className='bg-gray-50 text-white plb-0.5 pli-0.25 rounded-full size-4' />;
  }
}
